module.exports = __webpack_public_path__ + "static/Q1Answer4_Curlingupwithbook_AwarKurdish_1-5903dcbf29f388c241e8d8e99887d71c.jpg";